var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerMangement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic folder user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 15.9833L9.36667 14.65C10.575 10.25 15.7583 10.25 16.9667 14.65L17.3333 15.9833",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1673 11.3416C14.4467 11.3416 15.4839 10.3044 15.4839 9.02492C15.4839 7.74546 14.4467 6.70825 13.1673 6.70825C11.8878 6.70825 10.8506 7.74546 10.8506 9.02492C10.8506 10.3044 11.8878 11.3416 13.1673 11.3416Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.66699 14.9166H2.33366C1.89163 14.9166 1.46771 14.741 1.15515 14.4284C0.842587 14.1159 0.666992 13.6919 0.666992 13.2499V4.08325H15.667C16.109 4.08325 16.5329 4.25885 16.8455 4.57141C17.1581 4.88397 17.3337 5.30789 17.3337 5.74992",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.666999 7.24996V2.24996C0.666153 2.04135 0.743582 1.84 0.883988 1.68571C1.02439 1.53142 1.21756 1.4354 1.42533 1.41663H8.80867C8.90931 1.41861 9.0085 1.44105 9.10019 1.4826C9.19188 1.52415 9.27416 1.58393 9.342 1.65829L10.667 4.08329",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMangement);
export default __webpack_public_path__ + "static/media/customerMangement.0013c7213e59a806cc54dc3361098f49.svg";
export { ForwardRef as ReactComponent };